import { makeStyles, useTheme } from '@material-ui/core'
import { createStyles } from '@material-ui/styles'
import classNames from 'classnames'
import { useAppRunningContext } from 'features/EmbeddedRh24/useAppRunningContext'
import _ from 'lodash'
import { ImgHTMLAttributes } from 'react'
import { useAppSelector } from 'store/configureStore'
import { RootAppState } from 'store/configureStore'
import appLogo from '_icons/logo/QF_logoHrz_tag.png'

const useStyles = makeStyles(() =>
  createStyles({
    imgLogo: {
      display: 'block',
    },
  })
)

export const AppLogo = (props: ImgHTMLAttributes<HTMLImageElement>) => {
  const cn = useStyles()
  const theme = useTheme()

  const logoSrc = useAppSelector((state: RootAppState) =>
    _.isEmpty(state.app.theme?.logoSrc) ? appLogo : state.app.theme?.logoSrc
  )

  const { withinIframe } = useAppRunningContext()

  if (withinIframe && !theme?.logoSrc) {
    return null
  }

  return (
    <img
      src={logoSrc}
      alt="logo"
      {...props}
      className={classNames(cn.imgLogo, props.className)}
    />
  )
}
